import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.find";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import * as api from "@/api/overseasChinese/overseasChinese";
export default {
  name: "teacherTimetable",
  data: function data() {
    return {
      semesterList: [],
      searchObj: {
        semesterId: "",
        weekNo: 1
      },
      weekList: [],
      headerData: [],
      // 周一 - 周五处理数据
      listData: [],
      // 周一 - 周五处理数据
      sumHour: 0,
      keyword: "",
      rightTableData: []
    };
  },
  mounted: function mounted() {
    this.initData(); // this.getLeftTableData()
  },
  watch: {// "listData": {
    //     handler(val) {
    //         if (val) {
    //             this.rightTableData = val
    //         }
    //     },
    //     deep: true
    // }
  },
  methods: {
    initData: function initData() {
      this.tableLoading = true;
      this.getSemesterData();
    },
    getSemesterData: function getSemesterData() {
      var _this = this;

      api.getSemesterSel().then(function (_ref) {
        var data = _ref.data;
        _this.semesterList = data.data;
        var arr = data.data.find(function (item) {
          return item.current == 1;
        }) || data.data[0]; // let arr = data.data.find((item) => item.current == 1) || data.data[7]

        _this.searchObj.semesterId = arr.id;

        _this.getSchoolWeek();
      });
    },
    semesterClick: function semesterClick() {
      this.getSchoolWeek();
    },
    //获取右侧列表
    getTableList: function getTableList() {
      var _this2 = this;

      var listData_new = JSON.parse(JSON.stringify(this.listData)); // api.getMyKbTimeTab(this.searchObj).then(({data}) => {

      api.getNewMyKbTimeTab(this.searchObj).then(function (_ref2) {
        var data = _ref2.data;
        _this2.rightTableData = [];

        if (data.code === 0 && data.data.length > 0) {
          var resList = data.data;
          /*  let resData =   [
                            {
                                "id": "017519ff-8514-49c3-9f09-d9f62dff2602",
                                "courseId": "cf6ce1d7-3a41-474c-a285-427c05c5a9a1",
                                "courseName": "网店装修",
                                "weekNo": "18",
                                "day": "1",
                                "dayName": "周一",
                                "timeType": "am",
                                "index": "3",
                                "teacherNme": "罗俭",
                                "classroom": "新实训楼新实训楼406（爱电竞综合实训室）",
                                "semesterId": "b0486b3b-0613-4007-9a75-9dfc96927912",
                                "semesterName": "2021-2022学年第2学期",
                                "courseJcs": "2"
                            },
                                {
                                    "id": "87e0154a-0ce9-43dd-82f1-814f57acae61",
                                    "courseId": "cf6ce1d7-3a41-474c-a285-427c05c5a9a1",
                                    "courseName": "网店装修",
                                    "weekNo": "18",
                                    "day": "3",
                                    "dayName": "周三",
                                    "timeType": "am",
                                    "index": "1",
                                    "teacherNme": "罗俭",
                                    "classroom": "新实训楼新实训楼406（爱电竞综合实训室）",
                                    "semesterId": "b0486b3b-0613-4007-9a75-9dfc96927912",
                                    "semesterName": "2021-2022学年第2学期",
                                    "courseJcs": "5"
                                },
                                {
                                    "id": "2bfac17e-8f77-4474-aaf9-278fda895c3b",
                                    "courseId": "cf6ce1d7-3a41-474c-a285-427c05c5a9a1",
                                    "courseName": "网店装修",
                                    "weekNo": "18",
                                    "day": "5",
                                    "dayName": "周五",
                                    "timeType": "am",
                                    "index": "1",
                                    "teacherNme": "罗俭",
                                    "classroom": "新实训楼新实训楼406（爱电竞综合实训室）",
                                    "semesterId": "b0486b3b-0613-4007-9a75-9dfc96927912",
                                    "semesterName": "2021-2022学年第2学期",
                                    "courseJcs": "2"
                                }
                            ]*/

          listData_new.forEach(function (e) {
            for (var i = 0; i < resList.length; i++) {
              if (e.index === resList[i].index && e.timeType === resList[i].timeType) {
                var course = "week".concat(resList[i].day);
                e[course] = resList[i].courseName;
                e[course + "teacherNme"] = resList[i].teacherNme;
                e[course + "classroomName"] = resList[i].classroom;
                e["courseJcs" + (Number(resList[i].day) + 1)] = resList[i].courseJcs || "";
              }
            }
          });
          _this2.rightTableData = listData_new;
        } else if (data.data && data.data.length === 0) {
          _this2.rightTableData = _this2.listData;
        } else if (data.code === 1) {
          _this2.$alert(data.msg, "提示", {
            confirmButtonText: "确定",
            type: "warning"
          });
        }
      });
    },
    // 合并表格按照合并节次
    arraySpanMethod: function arraySpanMethod(_ref3) {
      var row = _ref3.row,
          column = _ref3.column,
          rowIndex = _ref3.rowIndex,
          columnIndex = _ref3.columnIndex;

      if (!columnIndex) {
        if (rowIndex === row.rowIndex) {
          // console.log(1,rowIndex);
          // console.log(2,row.rowIndex);
          return {
            rowspan: row.numCourse,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }

      if (columnIndex > 1) {
        if (row["courseJcs".concat(columnIndex)] > "1") {
          return {
            rowspan: row["courseJcs".concat(columnIndex)],
            colspan: 1
          };
        } else {
          // console.log(66,columnIndex);
          return {
            rowspan: 1,
            colspan: 1
          };
        }
      }
    },
    // 表头样式
    setHeaderStyle: function setHeaderStyle(_ref4) {
      var row = _ref4.row,
          column = _ref4.column,
          rowIndex = _ref4.rowIndex,
          columnIndex = _ref4.columnIndex;

      if (rowIndex === 0 && columnIndex === 0) {
        this.$nextTick(function () {
          if (document.getElementsByClassName(column.id).length !== 0) {
            document.getElementsByClassName(column.id)[0].setAttribute("rowSpan", 2);
            return false;
          }
        });
      }

      if (rowIndex === 1 && (columnIndex === 0 || columnIndex === 1)) {
        return {
          display: "none"
        };
      }
    },
    // 左边颜色
    rowNameClass: function rowNameClass(_ref5) {
      var row = _ref5.row,
          column = _ref5.column,
          rowIndex = _ref5.rowIndex,
          columnIndex = _ref5.columnIndex;

      if (columnIndex === 0 || columnIndex === 1) {
        if (row.timeType === "am") {
          return "shangWu";
        } else if (row.timeType === "pm") {
          return "xiaWu";
        } else if (row.timeType === "night") {
          return "wanShang";
        }

        if (row.timeType === "morning") {
          return "zaozixi";
        } else if (row.timeType === "noon") {
          return "zhongwu";
        } else if (row.timeType === "evening") {
          return "wanzixi";
        } else {
          return "";
        }
      }
    },
    formartDate: function formartDate(startTime, endTime) {
      return "".concat(startTime.substring(5), " ~ ").concat(endTime.substring(5));
    },
    // 获取周列表
    getSchoolWeek: function getSchoolWeek() {
      var _this3 = this;

      if (this.searchObj.semesterId) {
        var params = {
          semesterId: this.searchObj.semesterId
        };
        this.tableLoading = true;
        api.getWeekSel(params).then(function (_ref6) {
          var data = _ref6.data;

          if (data.code === 0) {
            _this3.weekList = data.data;
            _this3.searchObj.weekNo = data.data[0].weekNo;

            _this3.getHeaderNew(data.data[0].beginDate);
          } else {
            _this3.$alert(data.msg, "提示", {
              confirmButtonText: "确定",
              type: "warning"
            });
          }
        }).catch(function () {
          _this3.tableLoading = false;
        });
      }
    },
    selectWeek: function selectWeek(item) {
      this.searchObj.weekNo = item.weekNo;
      this.getTableList();
    },
    getHeaderNew: function getHeaderNew(time) {
      var _this4 = this;

      this.headerData = [];
      this.listData = [];
      this.sumHour = 0;
      var params = {
        semesterId: this.searchObj.semesterId,
        weekStartTime: time
      };
      api.getTimeTabWeek(params).then(function (_ref7) {
        var data = _ref7.data;

        if (data.code === 0) {
          var times = data.data.times;
          var infos = data.data.infos;
          var leftArr = [];
          var keysTime = Object.keys(times);
          var new_timeArr = []; // 处理按顺序储存

          var timeArrType = ["morning", "am", "noon", "pm", "night", "evening"];

          for (var i = 0; i < timeArrType.length; i++) {
            if (keysTime.indexOf(timeArrType[i]) > -1) {
              new_timeArr.push(timeArrType[i]);
            }
          }

          for (var _i = 0, _new_timeArr = new_timeArr; _i < _new_timeArr.length; _i++) {
            var item = _new_timeArr[_i];

            for (var j = 0; j < infos.length; j++) {
              if (item === infos[j].type) {
                var amObj = {
                  rowIndex: JSON.parse(JSON.stringify(_this4.sumHour)),
                  numlabel: "\u7B2C".concat(j + 1, "\u8282"),
                  time: _this4.handleLabel(item),
                  numCourse: times[item].length,
                  timeType: item,
                  endTime: infos[j].endTime,
                  index: infos[j].index,
                  startTime: infos[j].startTime,
                  type: item,
                  courseJcs: "0"
                };
                leftArr.push(amObj);
              }
            }

            _this4.sumHour += times[item].length;
          }

          _this4.listData = leftArr; // 头部

          for (var _i2 = 0; _i2 < 7; _i2++) {
            var o = {
              label: _this4.handleLabel(_i2 + 1),
              id: "week".concat(_i2 + 1)
            };

            _this4.headerData.push(o);
          }

          _this4.getTableList();
        } else {
          _this4.$alert(data.msg, "提示", {
            confirmButtonText: "确定",
            type: "warning"
          });
        }
      });
    },
    handleLabel: function handleLabel(num) {
      switch (num) {
        case 1:
          return "周一";

        case 2:
          return "周二";

        case 3:
          return "周三";

        case 4:
          return "周四";

        case 5:
          return "周五";

        case 6:
          return "周六";

        case 7:
          return "周日";

        case "morning":
          return "早自习";

        case "am":
          return "上午";

        case "noon":
          return "中午";

        case "pm":
          return "下午";

        case "night":
          return "晚上";

        case "evening":
          return "晚自习";

        default:
          return "";
      }
    }
  }
};